<template><span class="ai-name"><span class="ai-name-prefix">Ai</span>助理</span></template>
<script>
// 品牌名称仅调整中英文交界间距，保留原始文本；字体、字号和颜色继承使用位置。
export default { name: 'AiName' }
</script>
<style scoped>
.ai-name { white-space:nowrap; }
.ai-name-prefix { margin-right:0.15em; }
</style>
